import React from "react"
import PropTypes from "prop-types"
//import CardImage from "./CardImage.js"
import CardWidget from "./CardWidget.js"
import CardLink from "./CardLink.js"
import uniqueId from "lodash/uniqueId"
import LoadingSpinner from "./LoadingSpinner"
import { format_price_with_currency, format_percentage } from "./Helpers.js"

class CardsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.id = uniqueId("card-container-");
    this.state = {
      view_type: this.props.view_type,
      cards: this.props.cards,
      sort_type: "card_num",
      sort_order: "auto",
      columns: ["card_num", "name", "cost", "rarity", "price_paper", "price_changes_paper"],
    };
  }

  static sortCards(cards, sortType, sortOrder) {
    const raritySortOrder = ["Basic", "Common", "Uncommon", "Rare", "Mythic", "Bonus"];
    return cards.sort((a,b) => {
      var result = 0;
      if (sortType === "card_num") {
        result = a.card_num - b.card_num;
      } else if (sortType === "name") {
        result = a.display_name.localeCompare(b.display_name);
      } else if (sortType === "rarity") {
        const a_rarity = raritySortOrder.findIndex(e => e === a.rarity);
        const b_rarity = raritySortOrder.findIndex(e => e === b.rarity);
        result = a_rarity - b_rarity;
      } else if (sortType === "price_paper") {
        result = a.prices.paper.current_price - b.prices.paper.current_price
      } else if (sortType === "dod_delta_paper") {
        result = a.prices.paper.dod_delta - b.prices.paper.dod_delta
      } else if (sortType === "dod_pct_paper") {
        result = a.prices.paper.dod_pct - b.prices.paper.dod_pct
      } else if (sortType === "wow_delta_paper") {
        result = a.prices.paper.wow_delta - b.prices.paper.wow_delta
      } else if (sortType === "wow_pct_paper") {
        result = a.prices.paper.wow_pct - b.prices.paper.wow_pct
      } else if (sortType === "price_online") {
        result = a.prices.online.current_price - b.prices.online.current_price
      } else if (sortType === "dod_delta_online") {
        result = a.prices.online.dod_delta - b.prices.online.dod_delta
      } else if (sortType === "dod_pct_online") {
        result = a.prices.online.dod_pct - b.prices.online.dod_pct
      } else if (sortType === "wow_delta_online") {
        result = a.prices.online.wow_delta - b.prices.online.wow_delta
      } else if (sortType === "wow_pct_online") {
        result = a.prices.online.wow_pct - b.prices.online.wow_pct
      }

      if (sortOrder === "desc") {
        result = result * -1;
      } else if (sortOrder === "auto") {
        const columns = ["price_paper", "price_online", "rarity", "dod_delta_paper", "dod_pct_paper", "wow_delta_paper", "wow_pct_paper", "dod_delta_online", "dod_pct_online", "wow_delta_online", "wow_pct_online"];
        if (columns.includes(sortType)) {
          result = result * -1;
        }
      }

      return result;
    });
  }

	componentDidUpdate() {
		bindPopover();
	}
  componentDidMount() {
    this.setState({
      cards: this.constructor.sortCards(this.state.cards, this.state.sort_type, this.state.sort_order),
    });
  }


  onChangeSortType(e) {
    const newSortType = e.target.value;
    this.setState({
      sort_type: newSortType,
      cards: this.constructor.sortCards(this.state.cards, newSortType, this.state.sort_order),
    });
  }

  onChangeSortOrder(e) {
    const newSortOrder = e.target.value;
    this.setState({
      sort_order: newSortOrder,
      cards: this.constructor.sortCards(this.state.cards, this.state.sort_type, newSortOrder),
    });
  }

  onChangeColumnSelector(e) {
    const key = e.target.value;
    const checked = e.target.checked;

    var columns = this.state.columns;

    if (checked) {
      columns.push(key);
    } else {
      columns = columns.filter(item => item !== key);
    }

    this.setState({
      columns: columns,
    });
  }


	static getDerivedStateFromProps(props, state) {
		if (props.cards !== state.cards) {
			return {
				cards: CardsContainer.sortCards(props.cards, state.sort_type, state.sort_order),
			};
		}
		return null;
	}

  render () {
    var containerComponent;
    const columns = this.state.columns;
    if (this.state.view_type === "list") {
      var cardDatabaseComponents = this.state.cards.map(function(card_database) {
        var manaCostHTML = "";
        if (card_database.oracle) {
          manaCostHTML = card_database.oracle.mana_cost_html;
        }
        return (<tr key={card_database.name}>
          { columns.includes("card_num") && <td className="text-right">{card_database.card_num}</td> }
          <td><CardLink card={card_database}/></td>
          { columns.includes("cost") && <td><div dangerouslySetInnerHTML={ { __html: manaCostHTML } }/></td> }
          { columns.includes("rarity") && <td>{card_database.rarity}</td> }
          { columns.includes("price_paper") && <td className="text-right">{format_price_with_currency(card_database.prices.paper.current_price, "paper")}</td> }

          { columns.includes("price_changes_paper") && <td className="text-right">{format_price_with_currency(card_database.prices.paper.dod_delta, "paper")}</td> }
          { columns.includes("price_changes_paper") && <td className="text-right">{format_percentage(card_database.prices.paper.dod_pct, "paper")}</td> }
          { columns.includes("price_changes_paper") && <td className="text-right">{format_price_with_currency(card_database.prices.paper.wow_delta, "paper")}</td> }
          { columns.includes("price_changes_paper") && <td className="text-right">{format_percentage(card_database.prices.paper.dod_pct, "paper")}</td> }

          { columns.includes("price_online") && <td className="text-right">{format_price_with_currency(card_database.prices.online.current_price, "online")}</td> }
          { columns.includes("price_changes_online") && <td className="text-right">{format_price_with_currency(card_database.prices.online.dod_delta, "online")}</td> }
          { columns.includes("price_changes_online") && <td className="text-right">{format_percentage(card_database.prices.online.dod_pct, "online")}</td> }
          { columns.includes("price_changes_online") && <td className="text-right">{format_price_with_currency(card_database.prices.online.wow_delta, "online")}</td> }
          { columns.includes("price_changes_online") && <td className="text-right">{format_percentage(card_database.prices.online.dod_pct, "online")}</td> }
        </tr>);
      });
      containerComponent = (
        <React.Fragment>
          <div className="table-responsive">
            <table className='table table-striped table-sm'>
              <thead>
                <tr>
                  { columns.includes("card_num") && <th className="text-right">Card Num</th> }
                  <th>Card</th>
                  { columns.includes("cost") && <th>Mana Cost</th> }
                  { columns.includes("rarity") && <th>Rarity</th> }
                  { columns.includes("price_paper") && <th className="text-right">Tabletop Price</th> }
                  { columns.includes("price_changes_paper") && <th className="text-right">Daily Δ</th> }
                  { columns.includes("price_changes_paper") && <th className="text-right">Daily %</th> }
                  { columns.includes("price_changes_paper") && <th className="text-right">Weekly Δ</th> }
                  { columns.includes("price_changes_paper") && <th className="text-right">Weekly %</th> }

                  { columns.includes("price_online") && <th className="text-right">MTGO Price</th> }
                  { columns.includes("price_changes_online") && <th className="text-right">Daily Δ</th> }
                  { columns.includes("price_changes_online") && <th className="text-right">Daily %</th> }
                  { columns.includes("price_changes_online") && <th className="text-right">Weekly Δ</th> }
                  { columns.includes("price_changes_online") && <th className="text-right">Weekly %</th> }
                </tr>
              </thead>
              <tbody>
                {cardDatabaseComponents}
              </tbody>
            </table>
          </div>
          <p className="text-center text-muted">Showing {this.state.cards.length} Cards.</p>
        </React.Fragment>
      );
    } else if (this.state.view_type === "images") {
      var cardDatabaseComponents = this.state.cards.map(function(card_database) {
        return <CardWidget key={card_database.name} card_database={card_database}/>
        /*
        var extraClass = "";
        var noPrices = false;
        if (card_database.prices.paper.current_price && !card_database.prices.online.current_price) {
          extraClass = "widgetPriceCompact-prices-paper-only"
        } else if (!card_database.prices.paper.current_price && card_database.prices.online.current_price) {
          extraClass = "widgetPriceCompact-prices-online-only"
        } else if (!card_database.prices.paper.current_price && !card_database.prices.online.current_price) {
          extraClass = "widgetPriceCompact-prices-paper-only"
          noPrices = true;
        }

        return (
          <div className="spoiler-card" key={card_database.name}>
            <CardImage cardId={card_database.name} cardName={card_database.display_name} defaultImage={card_database.image_url} cardImages={card_database.images}/>
            <div className="widgetPriceCompact-prices clearfix">
              <div className={`widgetPriceCompact-prices-paper ${extraClass}`}>
                <a href="" className="btn btn-paper widgetPriceCompact-prices-link"> {format_price_with_currency(card_database.prices.paper.current_price, "paper", 2, (noPrices ? "-" : null))} </a>
              </div>
              <div className={`widgetPriceCompact-prices-online ${extraClass}`}>
                <a href="" className="btn btn-online widgetPriceCompact-prices-link"> {format_price_with_currency(card_database.prices.online.current_price, "online")} </a>
              </div>
            </div>
          </div>
          );
          */
      });
      containerComponent = (
        <React.Fragment>
          <div className="spoiler-card-container"> {cardDatabaseComponents} </div>
          <p className="text-center text-muted">Showing {this.state.cards.length} Cards.</p>
        </React.Fragment>
      );
    }

    const options = {
      card_num: "Card Num",
      cost: "Mana Cost",
      rarity: "Rarity",
      price_paper: "Tabletop: Price",
      price_changes_paper: "Tabletop: Price Changes",
      price_online: "MTGO: Price",
      price_changes_online: "MTGO: Price Changes",
    };

    const columnSelector = (<>{Object.keys(options).map(key => { return <div key={key} className="form-check form-check-inline"><input className="form-check-input" type="checkbox" name="columns" value={key} onChange={this.onChangeColumnSelector.bind(this)} defaultChecked={columns.includes(key)}/><label className="form-check-label">{options[key]}</label></div> })}</>);

    return (
      <React.Fragment>
        <div className="card-container-controls-container">
        <div className="card-container-controls card-container-view-type">
          <label htmlFor={`${this.id}-view`}>View As:</label>
          <select id={`${this.id}-view`} name="view_options" value={this.state.view_type} onChange={e => this.setState({view_type: e.target.value}) } className="form-control">
            <option value="list">List</option>
            <option value="images">Card Images</option>
          </select>
        </div>
        <div className="card-container-controls card-container-view-type">
          <label htmlFor={`${this.id}-sort_type`}>Sort:</label>
          <select id={`{$this.id}-sort_type`} name="sort_type" value={this.state.sort_type} onChange={this.onChangeSortType.bind(this)} className="form-control">
            <option value="card_num">Card Num</option>
            <option value="name">Card Name</option>
            <option value="rarity">Rarity</option>
            <option value="price_paper">Tabletop: Price</option>
            <option value="dod_delta_paper">Tabletop: Daily Δ</option>
            <option value="dod_pct_paper">Tabletop: Daily %</option>
            <option value="wow_delta_paper">Tabletop: Weekly Δ</option>
            <option value="dod_pct_paper">Tabletop: Weekly %</option>
            <option value="price_online">MTGO: Price</option>
            <option value="dod_delta_online">MTGO: Daily Δ</option>
            <option value="dod_pct_online">MTGO: Daily %</option>
            <option value="wow_delta_online">MTGO: Weekly Δ</option>
            <option value="dod_pct_online">MTGO: Weekly %</option>
          </select>
          <label htmlFor={`${this.id}-sort_order`} className="sr-only">Sort Order:</label>
          <select id={`${this.id}-sort_order`} name="sort_order" value={this.state.sort_order} onChange={this.onChangeSortOrder.bind(this)} className="form-control">
            <option value="auto">Auto</option>
            <option value="asc">Asc</option>
            <option value="desc">Desc</option>
          </select>
        </div>
        { this.state.view_type === "list" &&
          <>
            <div className="card-container-controls card-container-column-selector">
              <div className="form-check form-check-inline">
                <label className="column-selector-label">Columns:</label>
              </div>
              <div className="column-selector-container">
                {columnSelector}
              </div>
            </div>
          </>
        }
      </div>
      { this.props.loading ?
        <LoadingSpinner/>
      :
        containerComponent
      }
      </React.Fragment>
    );
  }
}

CardsContainer.propTypes = {
  greeting: PropTypes.string,
  cards: PropTypes.array,
  view_type: PropTypes.string,
};
export default CardsContainer
